import { GridApi, GridReadyEvent } from "ag-grid-community";
import { action, makeObservable, observable } from "mobx";
import PlacesApi, { PlacesApi as IPlacesApi } from "../../../../../../../../services/api/v2/places/Places.api";
import ModalContext from "../../../../../../../../core/modalZ/context/ModalContext";
import PlacesGroupsApi, {
  PlacesGroupsApi as IPlacesGroupsApi
} from "../../../../../../../../services/api/v2/places/PlacesGroups.api";
export interface IPlacesSummary {
  id: number;
  name: string;
  streetAddress: string;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
}

export class UnassignedPlacesModel {
  organisationId: number;
  placesProvider: IPlacesApi;
  placesGroupsProvider: IPlacesGroupsApi;
  @observable.ref selectedPlaces: any[] = [];
  @observable.ref places: IPlacesSummary[];
  @observable isLoading: boolean = true;
  gridApi: GridApi;
  @observable searchText: string;
  @observable placesColDefs: any[] = [];
  placeGroupId: number;

  constructor(organisationId: number, placeGroupId: number) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.placesProvider = PlacesApi;
    this.placeGroupId = placeGroupId;
    this.placesGroupsProvider = PlacesGroupsApi;
  }

  onMount = async () => {
    await this.loadPlaces();
  };

  onUnmount = () => {};

  @action
  OnGridReady = (gridReadyEvent: GridReadyEvent): void => {
    this.gridApi = gridReadyEvent.api;
    this.gridApi.setFilterModel({});
  };

  loadPlaces = async () => {
    let res = await this.placesProvider.getUnassignedPlaces(this.organisationId, this.placeGroupId);
    if (!res || res.isError) return;

    const payload = res.payload;

    this.setPlaces(this.mapToPlacesSummary(payload));

    if (payload?.columnDefs) {
      this.setPlacesColDefs(payload.columnDefs);
    }
    this.isLoading = false;
  };

  @action
  setPlacesColDefs = (placesColDefs: any[]) => {
    this.placesColDefs = placesColDefs;
  };
  @action
  setSearchText = (ev: React.FormEvent<HTMLInputElement>) => {
    this.searchText = ev.currentTarget.value;

    if (this.gridApi !== undefined) {
      this.gridApi.setGridOption("quickFilterText", this.searchText);
    }
  };
  assignPlaces = async selectedPlaces => {
    ModalContext.hide();
    let res = await this.placesGroupsProvider.bulkAdd(this.organisationId, this.placeGroupId, selectedPlaces);
    if (!res || res.isError) return;
    ModalContext.hide();
  };

  mapToPlacesSummary = (data: FP.Entities.IPlaceDetail[]): IPlacesSummary[] => {
    return data.map(e => {
      return {
        id: (e as any).id,
        name: e.name,
        streetAddress: e.streetAddress,
        city: e.city,
        country: e.country,
        latitude: e.latitude,
        longitude: e.longitude
      } as IPlacesSummary;
    });
  };

  @action
  setPlaces = (places: IPlacesSummary[]) => {
    this.places = places;
  };
}
